import { render, staticRenderFns } from "./CreateOrderView.vue?vue&type=template&id=489ea5fe&scoped=true&"
import script from "./CreateOrderView.vue?vue&type=script&lang=js&"
export * from "./CreateOrderView.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrderView.vue?vue&type=style&index=0&id=489ea5fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489ea5fe",
  null
  
)

export default component.exports